export const menuMap = [
  /**{
    label: "Gestione Quesiti",
    icon: "bi bi-question-circle",
    children: [
      {
        label: "Crea Quesito",
        view: "QuestionView",
        icon: "bi bi-plus-circle",
        requiredPermissions: ["create-question"]
      },
      {
        label: "Quesiti",
        view: "ListaQuesitiView",
        icon: "bi bi-list-ul",
        requiredPermissions: ["view-question", "edit-question"]
      }
    ]
  },*/
  /*{
    label: "Gestione Pareri",
    icon: "bi bi-chat-left-text",
    children: [
      {
        label: "Crea Parere",
        view: "CreaParereView",
        icon: "bi bi-plus-square",
        requiredPermissions: ["create-opinion"]
      },
      {
        label: "Lista Pareri",
        view: "ListaPareriView",
        icon: "bi bi-journal-text",
        requiredPermissions: ["view-opinion", "edit-opinion"]
      }
    ]
  },
  {
    label: "Gestione UOC",
    icon: "bi bi-diagram-3",
    view: "GestioneUOCView",
    requiredPermissions: ["manage-uoc"]
  },*/
  /*{
    label: "Tabella Quesiti",
    view: "QuestionsView",
    icon: "bi bi-folder-fill",
    requiredPermissions: ["view-questions", "edit-question"]
  },
  {
    label: "Quesiti",
    icon: "bi bi-folder-fill",
    requiredPermissions: ["view-questions", "edit-question"],
    children: [
      {
        label: "Tabella Quesiti",
        view: "QuestionsView",
        icon: "bi bi-table",
        requiredPermissions: ["view-questions"]
      },
      {
        label: "Da assegnare",
        view: "QuestionsToAssignView",
        icon: "bi bi-person-plus",
        requiredPermissions: ["edit-question"]
      }
    ]
  },*/
  {
    label: "Quesiti",
    icon: "bi bi-folder-fill",
    children: [
      {
        label: "Lista Quesiti",
        view: "QuestionsView",
        icon: "bi bi-table",
        requiredPermissions: ["view-questions", "edit-question","view-question"]
      },
      {
        label: "Countdown Quesiti",
        view: "QuestionsCountDownView",
        icon: "bi bi-hourglass",
         requiredPermissions: ["view-questions", "edit-question","view-question"]
      },
      {
        label: "Da assegnare",
        view: "QuestionsToAssignView",
        icon: "bi bi-person-plus",
         requiredPermissions: ["view-questions", "edit-question","view-question" ,"assign-question"]
      }
    ]
  },
  {
    label: 'Sala UOC',
    view: 'SalaAttesaSalaUOCView',
    icon: "bi bi-diagram-3",
    anyPermissions: ["manage-uoc", "view-uoc"]
  },
  {
    label: 'Download',
    view: 'ElencoDownloadView',
    icon: "bi bi-cloud-download",
    requiredPermissions: ['download-pdf']
  },
  ,
  {
    label: 'Analisi',
    view: 'StatisticsView',
    icon: "bi-pie-chart-fill",
    requiredPermissions: ['view-report']
  }
  ,

  {
    label: 'Dashboard',
    view: 'DashboardView',
    icon: "bi bi-speedometer2",
     requiredPermissions: ["view-questions", "edit-question","view-question"]
  }
  ,
  {
    label: 'Analisi - UOC',
    view: 'StatisticsUOCView',
    icon: "bi-pie-chart-fill",
    requiredPermissions: ['view-report-uoc']
  } ,
  {
    label: 'Utenti',
    view: 'UserListView',
    icon: "bi bi-people-fill",
    requiredPermissions: ['manage-users']
  },
    {
    label: 'Impostazioni',
    view: 'SettingsView',
    icon: "bi bi-gear-fill",
    requiredPermissions: ['manage-roles']
  }


];